import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

function Layout({ title, subtitle, actions, children }) {
  // Default: sidebar OPEN on desktop

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (window.innerWidth <= 768) return false;

    const saved = localStorage.getItem("crm-sidebar-open");
    return saved !== null ? saved === "true" : true;
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  // Close sidebar on route change (mobile only)
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // On desktop, default to open
      if (!mobile) {
        setSidebarOpen(false);
      } else {
        const saved = localStorage.getItem("crm-sidebar-open");
        setSidebarOpen(saved !== null ? saved === "true" : true);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close sidebar when Escape key is pressed
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && sidebarOpen && isMobile) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [sidebarOpen, isMobile]);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => {
      const next = !prev;
      localStorage.setItem("crm-sidebar-open", String(next));
      return next;
    });
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="app-shell">
      {/* Sidebar overlay for mobile */}
      <div
        className={`sidebar-overlay ${sidebarOpen && isMobile ? "active" : ""}`}
        onClick={closeSidebar}
      />

      <Sidebar isOpen={sidebarOpen} />

      <div
        className={`main-content ${sidebarOpen ? "sidebar-open" : "sidebar-collapsed"}`}
      >
        <Header onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />

        <main className="page-content">
          {title && (
            <div className="page-header">
              <div className="page-heading">
                <h1>{title}</h1>
                {subtitle && <p className="subtitle">{subtitle}</p>}
              </div>

              {actions && <div className="page-header-actions">{actions}</div>}
            </div>
          )}
          {children}
          <Outlet />
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default Layout;
